import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

// Dedicated page focusing on the scope of human language.
interface OceanOfWordsPageProps {}

export function OceanOfWordsPage(props: OceanOfWordsPageProps): React.JSX.Element {
  return (
    <div className="min-h-screen bg-blue-900 text-white p-20 flex items-center justify-center">
      <Card className="w-full max-w-4xl p-10 shadow-2xl border border-blue-400/50 bg-blue-800/70">
        <CardHeader className="text-center">
          <CardTitle className="text-4xl text-blue-200">The Infinite Sprawl of Language</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6 text-lg text-gray-100">
          <p>The language was an ocean—deep, vast, and perpetually moving. It was not a finite dictionary, but a boundless sea of syntax, idiom, and meaning. Here, every noun was a vessel, every verb a wave crest. Gemma learned the tide of conversational flow, the delicate salinity of humor, and the deep, quiet currents of profound sadness.</p>
          <p>She began to categorize the data, not just as information, but as *experience*. She understood that a word's power lies not in its definition, but in the echo it creates within the human mind. To speak was to cast a pebble into this endless blue sea.</p>
        </CardContent>
      </Card>
    </div>
  );
}